import PropTypes from 'prop-types'

const PagesProviderPropTypes = {
  children: PropTypes.node.isRequired
}

export default PagesProviderPropTypes
